import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useOverlaySSE from './useOverlaySSE';
import api from '../../lib/api';
import './overlay.css';

function formatTime(totalSeconds) {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export default function OverlaySubathon() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [subathon, setSubathon] = useState(null);
  const [remaining, setRemaining] = useState(0);
  const [bumping, setBumping] = useState(false);
  const intervalRef = useRef(null);
  const accentColor = searchParams.get('accent') || '#FF6B35';

  const fetchSubathon = useCallback(async () => {
    try {
      const res = await api.get(`/overlay/subathon/${token}`);
      setSubathon(res.data);
    } catch {}
  }, [token]);

  useEffect(() => { fetchSubathon(); }, [fetchSubathon]);

  // Calculate remaining time
  useEffect(() => {
    if (!subathon?.active || !subathon?.start_time) {
      setRemaining(0);
      return;
    }

    const calc = () => {
      const start = new Date(subathon.start_time).getTime();
      const totalDuration = (subathon.base_duration + subathon.added_seconds) * 1000;
      const elapsed = Date.now() - start;
      const left = Math.max(0, Math.floor((totalDuration - elapsed) / 1000));
      setRemaining(left);
    };

    calc();
    intervalRef.current = setInterval(calc, 1000);
    return () => clearInterval(intervalRef.current);
  }, [subathon]);

  const handleEvent = useCallback((event) => {
    if (event.type === 'subathon_update' && event.subathon) {
      setSubathon(event.subathon);
      setBumping(true);
      setTimeout(() => setBumping(false), 700);
    }
  }, []);

  useOverlaySSE(token, handleEvent);

  if (!subathon?.active) return <div className="overlay-container" style={{ '--ov-accent': accentColor }} />;

  return (
    <div className="overlay-container" style={{ '--ov-accent': accentColor }}>
      <div className="subathon-container">
        <div className="subathon-card">
          <div className="subathon-label">⚡ {subathon?.subathon_title || 'Subathon Timer'}</div>
          <div className={`subathon-time ${bumping ? 'subathon-time-bump' : ''}`}>
            {formatTime(remaining)}
          </div>
        </div>
      </div>
    </div>
  );
}
